import './styles/footer.css'
function Footer() {
    return (
        <div className="footer">
            <div className='links'>
                <a href="/privacy-policies" target="_blank">Privacy Policies</a>
                <a href="/terms-and-conditions" target="_blank">Termini e Condizioni</a>
            </div>
            <p>© STARQ LAB - Virgilio Quaresima - info@starqlab.com</p>
        </div>
    )
}

export default Footer